export function isAbortError(error: unknown): boolean {
	const err = error as { name?: unknown; code?: unknown; message?: unknown } | null;
	if (!err || typeof err !== "object") {
		return false;
	}

	// fetch() abort
	if (err.name === "AbortError") {
		return true;
	}

	// Some runtimes/libraries (and older code) use a code
	if (err.code === "ABORT_ERR") {
		return true;
	}

	return false;
}

